import { type SessionCreationStepKey } from '../SessionCreationContext';

export const STEP_TO_ACTIVE_MAP: Record<SessionCreationStepKey, number> = {
  patient: 0,
  device: 1,
  sessionType: 2,
  configuration: 3,
};
